export enum AlertBannerName {
  NO_DATA = "noData",
  NO_DATA_AND_YOUNGER_THAN_WEEK = "noDataAndYoungerThanWeek",
  NO_DATA_IN_PERIOD_AND_DATA_OUTSIDE = "noDataInPeriodAndDataOutside",
  PAYMENT_PENDING = "paymentPending",
  PAYMENT_ERROR = "paymentError",
  PAYMENT_EMPTY = "paymentEmpty",
  PAYMENT_UNAPPROVED = "paymentUnapproved",
}
